import React, { useEffect, useState } from "react";
import { TreeNode, NodeType } from "./TreeNodeComponent";
import { TreeWrapper } from "./treeUtils";

type Props = {
  trees: TreeWrapper[];
  preSelectedIds?: string[];
  onFetch: (selectedItems: Array<{ id: string, fk_videoModule_id: string | null }>) => void;
};

export const TreeMain: React.FC<Props> = ({ trees, onFetch, preSelectedIds = [] }) => {
  const [checked, setChecked] = useState<Record<string, boolean>>(
    preSelectedIds.reduce((acc, id) => ({ ...acc, [id]: true }), {})
  );

  const handleCheck = (id: string, isChecked: boolean) => {
    const newChecked = { ...checked, [id]: isChecked };
    setChecked(newChecked);
  };

  useEffect(() => {
    const selectedItems = Object.entries(checked)
      .filter(([_, isChecked]) => isChecked)
      .map(([id]) => {
        // Find which module this node belongs to
        for (const tree of trees) {
          const findNodeInTree = (nodes: NodeType[]): NodeType | null => {
            for (const node of nodes) {
              if (node.id === id) return node;
              if (node.children) {
                const found = findNodeInTree(node.children);
                if (found) return found;
              }
            }
            return null;
          };
          
          const node = findNodeInTree(tree.treeData);
          if (node) {
            return {
              id: id,
              fk_videoModule_id: tree.treeData[0]?.fk_videoModule_id || null
            };
          }
        }
        return { id, fk_videoModule_id: null };
      });
    
    onFetch(selectedItems);
  }, [checked, onFetch, trees]);

  return (
    <div className="p-2 bg-white rounded-lg max-h-[300px] overflow-auto mb-3">
      {trees.map(({ module, treeData }) => (
        <div className="bg-gray-200 rounded-lg p-2 mb-3" key={module}>
          <h3 className="bg-purple-700 text-white py-1 px-3 rounded-lg">{module}</h3>
          {treeData?.length > 0 &&
            treeData.map((node: NodeType) => (
              <TreeNode
                key={node.id}
                node={node}
                checked={checked}
                onCheck={handleCheck}
              />
            ))}
        </div>
      ))}
    </div>
  );
};